import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentVenue } from '../../../redux/slices/currentUserSlice';
import OperatingHours from '../OperatingHours/OperatingHours';
import LocationAndContact from '../LocationAndContact/LocationAndContact';
import Reporting from '../Reporting/Reporting';
import TimezoneInfo from '../TimezoneInfo/TimezoneInfo';
import { GeneralInfoContainer, LocationTimezoneRow, LocationContainer, TimezoneContainer } from './GeneralInfo.styles';
const GeneralInfo = () => {
  const { startOfWeekIndex, name, address } = useSelector(selectCurrentVenue);

  return (
    <GeneralInfoContainer>
      {/* Location and Timezone side by side */}
      <LocationTimezoneRow>
        <LocationContainer>
          <LocationAndContact name={name} address={address} />
        </LocationContainer>
        <TimezoneContainer>
          <TimezoneInfo />
        </TimezoneContainer>
      </LocationTimezoneRow>

      <Reporting startOfWeekIndex={startOfWeekIndex} />
      <OperatingHours startOfWeekIndex={startOfWeekIndex} />
    </GeneralInfoContainer>
  );
};

export default GeneralInfo;
